// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
import { getAuth, GoogleAuthProvider} from 'firebase/auth';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyAiVxeG9Hba9-r1F_da_CmtyInrP7aYnx0",
  authDomain: "fir-crud-c3cb0.firebaseapp.com",
  projectId: "fir-crud-c3cb0",
  storageBucket: "fir-crud-c3cb0.appspot.com",
  messagingSenderId: "9430998398",
  appId: "1:9430998398:web:738f13d50716793934272f",
  measurementId: "G-6YDFRG7M8N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
